import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useLayoutEffect } from 'react';

import { AuthProvider, useAuth } from './features/auth';
import { Login, Signup, Callback, Onboarding } from './features/auth';
import { LandingPage, ComingSoon } from './features/landing';
import { Dashboard } from './features/dashboard';
import { EULA, Privacy } from './features/legal';
import { Invite } from './features/invite';

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }, [pathname]);
  return null;
};

const ProtectedRoute = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-zinc-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user || !isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<ComingSoon />} />
          <Route path="/preview" element={<LandingPage />} />
          <Route path="/eula" element={<EULA />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/quickbooks" element={<Navigate to="/dashboard/integrations" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          <Route path="/callback" element={<Callback />} />
          <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
          <Route path="/invite/:token" element={<Invite />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
